<template>
  <div class="iphone18">
    <div class="iphone18__side iphone18__side--left">
      <span class="iphone18__key iphone18__key--silent"></span>
      <span class="iphone18__key iphone18__key--vol-up"></span>
      <span class="iphone18__key iphone18__key--vol-down"></span>
    </div>
    <span class="iphone18__key iphone18__key--power"></span>

    <div class="iphone18__shell">
      <div class="iphone18__bezel">
        <div class="iphone18__screen">
          <div class="iphone18__status">
            <span class="iphone18__time">9:41</span>
            <div class="iphone18__island">
              <span class="iphone18__island-cam"></span>
            </div>
            <div class="iphone18__status-right">
              <span class="iphone18__signal"></span>
              <span class="iphone18__wifi"></span>
              <span class="iphone18__battery"></span>
            </div>
          </div>

          <div class="iphone18__content">
            <div class="iphone18__scroll">
              <div class="mp-phone__banner">
                <img v-if="bannerUrl" :src="bannerUrl" alt="" />
              </div>
              <div class="mp-phone__main">
                <div class="mp-phone__act">{{ actName }}</div>
                <div class="mp-phone__time">{{ timeText }}</div>
                <div v-if="playStyleLabelText" class="mp-phone__style-tag">{{ playStyleLabelText }}</div>

                <!-- 大转盘 -->
                <div v-if="playStyle === 'wheel'" class="mp-phone__wheel-wrap">
                  <div class="mp-phone__wheel" :style="wheelPlateStyle">
                    <div
                      v-for="(p, i) in wheelPrizes"
                      :key="`${p.name}-${i}`"
                      class="mp-phone__sector"
                      :style="sectorStyle(i)"
                    >
                      <span class="mp-phone__sector-text">{{ p.name }}</span>
                    </div>
                    <div class="mp-phone__wheel-btn" :style="{ borderColor: themeColor }">
                      {{ actionLabel }}
                    </div>
                  </div>
                </div>

                <!-- 九宫格 -->
                <div v-else-if="playStyle === 'grid'" class="mp-phone__grid-wrap">
                  <div class="mp-phone__grid">
                    <div
                      v-for="(cell, i) in gridCells"
                      :key="i"
                      class="mp-phone__grid-cell"
                      :class="{ 'is-center': i === 4 }"
                      :style="i === 4 ? { background: themeColor, color: '#fff' } : undefined"
                    >
                      {{ cell }}
                    </div>
                  </div>
                </div>

                <!-- 刮刮乐 -->
                <div v-else-if="playStyle === 'scratch'" class="mp-phone__scratch-wrap">
                  <div class="mp-phone__scratch-card" :style="{ borderColor: themeColor }">
                    <div class="mp-phone__scratch-cover">刮开试试</div>
                    <div class="mp-phone__scratch-hint">刮奖区</div>
                  </div>
                </div>

                <!-- 裂变 -->
                <div v-else-if="playStyle === 'fission'" class="mp-phone__generic-wrap">
                  <div class="mp-phone__generic-card" :style="{ borderColor: themeColor }">
                    <div class="mp-phone__generic-title">邀请好友助力</div>
                    <div class="mp-phone__generic-btn" :style="{ background: themeColor }">
                      立即{{ actionLabel }}
                    </div>
                    <div class="mp-phone__generic-sub">已邀请 0 人 · 目标 3 人</div>
                  </div>
                </div>

                <!-- 投票 -->
                <div v-else-if="playStyle === 'vote'" class="mp-phone__generic-wrap">
                  <div class="mp-phone__vote-item">选项 A · 0 票</div>
                  <div class="mp-phone__vote-item">选项 B · 0 票</div>
                  <div class="mp-phone__generic-btn" :style="{ background: themeColor }">
                    提交{{ actionLabel }}
                  </div>
                </div>

                <!-- 答题 -->
                <div v-else-if="playStyle === 'quiz'" class="mp-phone__generic-wrap">
                  <div class="mp-phone__generic-card">
                    <div class="mp-phone__generic-title">第 1 题</div>
                    <div class="mp-phone__quiz-q">示例题目，请选择正确答案</div>
                    <div class="mp-phone__vote-item">A. 选项一</div>
                    <div class="mp-phone__vote-item">B. 选项二</div>
                  </div>
                </div>

                <!-- 签到 -->
                <div v-else-if="playStyle === 'signin'" class="mp-phone__generic-wrap">
                  <div class="mp-phone__signin-row">
                    <span
                      v-for="d in 7"
                      :key="d"
                      class="mp-phone__signin-day"
                      :class="{ 'is-done': d <= 3 }"
                    >
                      {{ d }}
                    </span>
                  </div>
                  <div class="mp-phone__generic-btn" :style="{ background: themeColor }">
                    今日{{ actionLabel }}
                  </div>
                </div>

                <!-- 兜底 -->
                <div v-else class="mp-phone__wheel-wrap">
                  <div class="mp-phone__wheel" :style="wheelPlateStyle">
                    <div class="mp-phone__wheel-btn" :style="{ borderColor: themeColor }">参与</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="iphone18__tabdock">
              <div class="mp-phone__tabs">
                <span
                  v-for="(tab, i) in tabs"
                  :key="tab.key"
                  class="mp-phone__tab"
                  :class="{ 'is-active': activeTab === i }"
                  :style="activeTab === i ? tabActiveStyle : undefined"
                  @click="activeTab = i"
                >
                  {{ tab.title }}
                </span>
              </div>

              <div v-if="activeTab === 0" class="mp-phone__panel">
                <div class="mp-phone__rules">{{ rulesText || '请填写活动规则' }}</div>
              </div>
              <div v-else-if="activeTab === 1" class="mp-phone__panel">
                <div class="mp-phone__empty">参与活动后，您的中奖记录将显示在这里</div>
              </div>
              <div v-else class="mp-phone__panel">
                <div v-if="!previewWinners.length" class="mp-phone__empty">暂无中奖记录</div>
                <div v-for="(w, i) in previewWinners" :key="`win-${i}`" class="mp-phone__winner">
                  <span class="mp-phone__winner-name">{{ w.nickname }}</span>
                  <span class="mp-phone__winner-prize">{{ w.prizeName }}</span>
                </div>
                <div v-if="winablePrizes.length" class="mp-phone__sub-title">可中奖品</div>
                <div v-for="(p, i) in winablePrizes" :key="`pool-${i}`" class="mp-phone__prize">
                  <span>{{ p.name }}</span>
                  <span class="mp-phone__prize-type">{{ p.type }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="iphone18__home-bar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import type { MarketPrizeRow } from '../../mock/types'
import { playActionLabel, playStyleLabel } from '../playStyles'

defineOptions({ name: 'MarketPhonePreview' })

const props = withDefaults(
  defineProps<{
    actName?: string
    bannerUrl?: string
    themeColor?: string
    playStyle?: string
    startTime?: string
    endTime?: string
    rulesText?: string
    prizes?: MarketPrizeRow[]
    pageTabs?: Array<{ key: string; title: string }>
  }>(),
  {
    actName: '活动名称',
    themeColor: '#ff6c6c',
    playStyle: 'wheel',
    rulesText: ''
  }
)

const tabs = computed(() => {
  const list = props.pageTabs?.filter((t) => t?.title)
  if (list?.length) return list
  return [
    { key: 'rules', title: '活动规则' },
    { key: 'myAwards', title: '我的奖品' },
    { key: 'winners', title: '中奖名单' }
  ]
})
const activeTab = ref(0)

watch(
  tabs,
  () => {
    if (activeTab.value >= tabs.value.length) activeTab.value = 0
  },
  { deep: true }
)

const playStyleLabelText = computed(() => playStyleLabel(props.playStyle))
const actionLabel = computed(() => playActionLabel(props.playStyle))

const formatRange = (start?: string, end?: string) => {
  if (!start && !end) return '请设置活动时间'
  const s = start ? start.slice(0, 16) : '-'
  const e = end ? end.slice(0, 16) : '-'
  return `${s} 至 ${e}`
}

const timeText = computed(() => formatRange(props.startTime, props.endTime))
const rulesText = computed(() => props.rulesText?.trim() || '')

const wheelPrizes = computed(() => {
  const list = (props.prizes || []).filter((p) => p.name)
  return list.length ? list : [{ name: '谢谢参与', type: '空', count: 0, probability: 100 }]
})

const gridCells = computed(() => {
  const names = wheelPrizes.value.slice(0, 8).map((p) => p.name)
  while (names.length < 8) names.push('谢谢参与')
  names.splice(4, 0, '抽奖')
  return names
})

const winablePrizes = computed(() =>
  wheelPrizes.value.filter((p) => p.type !== '空' && !String(p.name).includes('谢谢'))
)

const previewWinners = computed(() => [])

const tabActiveStyle = computed(() => ({
  color: props.themeColor || '#ff6c6c',
  borderBottomColor: props.themeColor || '#ff6c6c'
}))

const wheelPlateStyle = computed(() => {
  const c = props.themeColor || '#ff6c6c'
  const n = wheelPrizes.value.length
  const step = 360 / n
  const stops: string[] = []
  for (let i = 0; i < n; i++) {
    const color = i % 2 === 0 ? `${c}55` : `${c}22`
    stops.push(`${color} ${i * step}deg ${(i + 1) * step}deg`)
  }
  return {
    background: `conic-gradient(${stops.join(', ')})`,
    border: `8px solid ${c}`
  }
})

const sectorStyle = (index: number) => {
  const n = wheelPrizes.value.length
  const step = 360 / n
  const rotate = index * step + step / 2
  return {
    transform: `rotate(${rotate}deg) translateY(-62px)`
  }
}
</script>

<style lang="scss" scoped>
.iphone18 {
  position: relative;
  width: 320px;
  margin: 0 auto;
  padding: 0 4px;
  filter: drop-shadow(0 24px 48px rgb(15 23 42 / 22%));

  &__side {
    position: absolute;
    top: 118px;
    left: -3px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 2;
  }

  &__key {
    display: block;
    border-radius: 2px;
    background: linear-gradient(180deg, #8e95a3 0%, #636b78 45%, #4a5160 100%);
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 35%),
      inset 0 -1px 0 rgb(0 0 0 / 25%);

    &--silent {
      width: 3px;
      height: 18px;
    }

    &--vol-up,
    &--vol-down {
      width: 3px;
      height: 34px;
    }

    &--power {
      position: absolute;
      top: 148px;
      right: -3px;
      width: 3px;
      height: 58px;
      z-index: 2;
    }
  }

  &__shell {
    position: relative;
    padding: 3px;
    border-radius: 54px;
    background: linear-gradient(
      145deg,
      #cfd5df 0%,
      #9aa3b2 18%,
      #eef1f6 38%,
      #7d8798 58%,
      #b8beca 78%,
      #6f7888 100%
    );
    box-shadow:
      inset 0 0 0 1px rgb(255 255 255 / 45%),
      inset 0 0 0 2px rgb(0 0 0 / 12%),
      0 0 0 1px rgb(0 0 0 / 8%);
  }

  &__bezel {
    padding: 10px 8px 12px;
    border-radius: 50px;
    background: #090909;
  }

  &__screen {
    position: relative;
    height: 640px;
    border-radius: 42px;
    overflow: hidden;
    background: #000;
    display: flex;
    flex-direction: column;
  }

  &__status {
    position: relative;
    z-index: 3;
    height: 44px;
    padding: 12px 18px 0;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: start;
    color: #fff;
    background: linear-gradient(180deg, rgb(0 0 0 / 55%) 0%, transparent 100%);
  }

  &__time {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  &__island {
    width: 96px;
    height: 28px;
    margin: 0 auto;
    border-radius: 20px;
    background: #000;
    box-shadow:
      inset 0 0 0 1px rgb(255 255 255 / 6%),
      0 1px 8px rgb(0 0 0 / 45%);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  &__island-cam {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 35%, #4a5568, #0f172a 70%);
    box-shadow: inset 0 0 0 1px rgb(255 255 255 / 12%);
  }

  &__status-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
  }

  &__signal,
  &__wifi,
  &__battery {
    display: inline-block;
    opacity: 0.95;
  }

  &__signal {
    width: 14px;
    height: 10px;
    background:
      linear-gradient(to top, #fff 0 0) 0 100% / 3px 35% no-repeat,
      linear-gradient(to top, #fff 0 0) 4px 100% / 3px 55% no-repeat,
      linear-gradient(to top, #fff 0 0) 8px 100% / 3px 75% no-repeat,
      linear-gradient(to top, #fff 0 0) 12px 100% / 3px 100% no-repeat;
  }

  &__wifi {
    width: 12px;
    height: 9px;
    border: 2px solid #fff;
    border-top-color: transparent;
    border-radius: 50%;
  }

  &__battery {
    width: 18px;
    height: 9px;
    border: 1.5px solid rgb(255 255 255 / 85%);
    border-radius: 3px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      inset: 1.5px 4px 1.5px 1.5px;
      border-radius: 1px;
      background: #fff;
    }

    &::after {
      content: '';
      position: absolute;
      right: -3px;
      top: 2px;
      width: 2px;
      height: 4px;
      border-radius: 0 1px 1px 0;
      background: rgb(255 255 255 / 85%);
    }
  }

  &__content {
    flex: 1;
    min-height: 0;
    margin-top: -44px;
    padding-top: 44px;
    display: flex;
    flex-direction: column;
    background: #f7f8fa;
  }

  &__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  &__tabdock {
    flex-shrink: 0;
    background: #f7f8fa;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -4px 12px rgb(0 0 0 / 4%);
  }

  &__home-bar {
    flex-shrink: 0;
    height: 20px;
    background: #f7f8fa;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 6px;
      width: 108px;
      height: 4px;
      margin-left: -54px;
      border-radius: 999px;
      background: #111;
      opacity: 0.82;
    }
  }
}

.mp-phone {
  &__banner {
    height: 118px;
    background: linear-gradient(135deg, #ffb347, #ff6c6c);
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__body {
    flex: 1;
    padding: 12px 12px 8px;
    overflow-y: auto;
  }

  &__main {
    padding: 12px 12px 8px;
  }

  &__act {
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2px;
    color: #303133;
  }

  &__time {
    font-size: 10px;
    color: #b0b3ba;
    text-align: center;
    margin-bottom: 6px;
  }

  &__style-tag {
    text-align: center;
    font-size: 10px;
    color: #909399;
    margin-bottom: 8px;
  }

  &__wheel-wrap,
  &__grid-wrap,
  &__scratch-wrap,
  &__generic-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
  }

  &__wheel {
    width: 190px;
    height: 190px;
    border-radius: 50%;
    position: relative;
    box-shadow: 0 3px 8px rgb(255 108 108 / 35%);
  }

  &__sector {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    transform-origin: 0 0;
  }

  &__sector-text {
    display: inline-block;
    max-width: 56px;
    font-size: 9px;
    line-height: 1.2;
    color: #fff;
    text-shadow: 0 1px 2px rgb(0 0 0 / 35%);
    text-align: center;
    word-break: break-all;
    transform: translate(-50%, -50%) rotate(-90deg);
  }

  &__wheel-btn {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 52px;
    height: 52px;
    margin: -26px 0 0 -26px;
    border-radius: 50%;
    background: #fff;
    border: 3px solid #ff6c6c;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #ff6c6c;
    box-shadow: 0 2px 6px rgb(0 0 0 / 12%);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    width: 210px;
  }

  &__grid-cell {
    aspect-ratio: 1;
    background: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    text-align: center;
    padding: 4px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 8%);
  }

  &__scratch-card {
    width: 210px;
    height: 120px;
    border-radius: 10px;
    border: 2px dashed #ff6c6c;
    background: linear-gradient(135deg, #fff7e6, #ffe7ba);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  &__scratch-cover {
    width: 160px;
    height: 56px;
    border-radius: 8px;
    background: linear-gradient(135deg, #c0c4cc, #909399);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
  }

  &__scratch-hint {
    font-size: 11px;
    color: #909399;
  }

  &__generic-card {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    border: 1px solid #eee;
  }

  &__generic-title {
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 10px;
  }

  &__generic-sub {
    margin-top: 8px;
    font-size: 11px;
    color: #909399;
    text-align: center;
  }

  &__generic-btn {
    display: block;
    width: 100%;
    max-width: 210px;
    margin: 0 auto;
    padding: 10px;
    border-radius: 20px;
    color: #fff;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
  }

  &__vote-item {
    width: 100%;
    max-width: 210px;
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
    margin-bottom: 8px;
  }

  &__quiz-q {
    font-size: 12px;
    color: #606266;
    margin-bottom: 10px;
    line-height: 1.5;
  }

  &__signin-row {
    display: flex;
    gap: 6px;
    justify-content: center;
    margin-bottom: 12px;
  }

  &__signin-day {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #eee;
    color: #909399;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.is-done {
      background: #67c23a;
      color: #fff;
    }
  }

  &__tabs {
    display: flex;
    border-bottom: 1px solid #eee;
    background: #fff;
  }

  &__tab {
    flex: 1;
    text-align: center;
    font-size: 11px;
    color: #909399;
    padding: 8px 0;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;

    &.is-active {
      font-weight: 700;
    }
  }

  &__panel {
    min-height: 88px;
    max-height: 120px;
    overflow-y: auto;
    background: #fff;
  }

  &__rules {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.6;
    color: #606266;
    white-space: pre-wrap;
  }

  &__empty {
    text-align: center;
    color: #b0b3ba;
    font-size: 12px;
    padding: 16px 8px 10px;
  }

  &__sub-title {
    margin: 8px 0 6px;
    font-size: 11px;
    color: #909399;
  }

  &__prize {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
    color: #606266;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__prize-type {
    color: #ff9d5c;
  }

  &__winner {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__winner-name {
    color: #303133;
  }

  &__winner-prize {
    color: #ff6c6c;
  }
}
</style>
